import { messages } from '@databases/intl/messages';
import { SkeletonItem } from '@databases/skeleton';
import { DatabaseField } from '@databases/types/database';
import React, { FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';

import FieldTypeIcon from '../FieldTypeIcon';

import FieldNameContainer from './FieldNameContainer';

export interface FieldNameProps {
  field: DatabaseField;
  showIcon?: boolean;
}

/**
 * Renders the name of a database field. If the name is empty, a placeholder is shown. Optionally, the field name
 * can be decorated with an icon indicating the field type.
 */
const FieldName: FunctionComponent<FieldNameProps> = ({ field, showIcon }) => {
  const { formatMessage } = useIntl();

  return (
    <FieldNameContainer>
      {showIcon && (
        <SkeletonItem isButton>
          <FieldTypeIcon type={field.type} noTooltip />
        </SkeletonItem>
      )}
      <SkeletonItem minWidth={80}>
        <span>{field.name || formatMessage(messages['field.default-field-name'])}</span>
      </SkeletonItem>
    </FieldNameContainer>
  );
};

export default FieldName;
